import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from "react";
import { j as useResolvedAttributes, B as Box } from "./Grid-CcQKdsgp.js";
import { F as Flex } from "./Flex-BqkSIn_m.js";
import { T as Typography } from "./Typography-BcQZigNB.js";
import { useToggleState } from "@react-stately/toggle";
import { useCheckbox } from "@react-aria/checkbox";
const SvgCheckboxIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M15.39.566a1.043 1.043 0 0 1 0 1.476L6 11.433a1.043 1.043 0 0 1-1.477 0L.61 7.52a1.043 1.043 0 1 1 1.476-1.475L5.261 9.22 13.915.566a1.043 1.043 0 0 1 1.475 0",
        clipRule: "evenodd"
      }
    )
  }
);
const Checkbox = forwardRef(
  ({
    children,
    value,
    onChange,
    className = "",
    errorMessage,
    customCheckbox,
    customWrapper,
    ...rest
  }, ref) => {
    const localRef = useRef(null);
    const inputRef = ref != null ? ref : localRef;
    const state = useToggleState({ isSelected: value, onChange });
    const { inputProps } = useCheckbox(rest, state, inputRef);
    const resolvedProps = useResolvedAttributes(rest);
    const CustomCheckbox = customCheckbox ? customCheckbox({ isSelected: state.isSelected }) : /* @__PURE__ */ jsx(Fragment, {});
    const InnerContent = /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          ...inputProps,
          ref: inputRef,
          type: "checkbox",
          className: "opacity-0 absolute"
        }
      ),
      customCheckbox ? CustomCheckbox : /* @__PURE__ */ jsx(
        Flex,
        {
          as: "span",
          align: "center",
          justify: "center",
          bg: state.isSelected ? "surface-primary-default" : "",
          border: {
            radius: "checkbox",
            width: "2px",
            color: state.isSelected ? "surface-primary-default" : "border-button"
          },
          cursor: "pointer",
          minWidth: 24,
          width: 24,
          height: 24,
          minHeight: 24,
          className,
          ...rest,
          children: state.isSelected && /* @__PURE__ */ jsx(SvgCheckboxIcon, {})
        }
      ),
      children
    ] });
    return /* @__PURE__ */ jsxs(Box, { children: [
      customWrapper ? customWrapper({
        isSelected: state.isSelected,
        children: InnerContent
      }) : /* @__PURE__ */ jsx(
        Flex,
        {
          ...resolvedProps,
          as: "label",
          align: "center",
          gap: 8,
          cursor: "pointer",
          children: InnerContent
        }
      ),
      typeof errorMessage === "string" ? /* @__PURE__ */ jsx(
        Typography,
        {
          lineHeight: "body.mobile.small",
          fontSize: "body.mobile.small",
          fontWeight: "mobile.normal",
          md: { fontWeight: "desktop.normal" },
          as: "span",
          color: "text-destructive",
          children: errorMessage
        }
      ) : errorMessage
    ] });
  }
);
export {
  Checkbox as C
};
